import { render, staticRenderFns } from "./customerIndex.vue?vue&type=template&id=dd32b64c&scoped=true"
import script from "./customerIndex.vue?vue&type=script&lang=js"
export * from "./customerIndex.vue?vue&type=script&lang=js"
import style0 from "./customerIndex.vue?vue&type=style&index=0&id=dd32b64c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd32b64c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd32b64c')) {
      api.createRecord('dd32b64c', component.options)
    } else {
      api.reload('dd32b64c', component.options)
    }
    module.hot.accept("./customerIndex.vue?vue&type=template&id=dd32b64c&scoped=true", function () {
      api.rerender('dd32b64c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bulletinBoard/customerIndex.vue"
export default component.exports